// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"search-content_contentWrapper__tFJqa","productsGrid":"search-content_productsGrid__7WiG1","notFoundText":"search-content_notFoundText__T2_NO"};